/** @format */

import get from 'lodash/get';
import { getLS } from 'utility';
import AuthApi from 'components/Auth/Api';
import FileSaver from 'file-saver';
import Axios from 'axios';

let baseUrl;
if (process.env?.REACT_APP_API_JAVA) {
  baseUrl = `${process.env.REACT_APP_API_JAVA}${process.env.REACT_APP_BASE_URL}`;
} else {
  baseUrl = `${process.env.REACT_APP_BASE_URL}`;
}
export class AuthService {
  TOKEN_KEY_NAME = 'TOKEN';

  REFRESH_TOKEN_KEY = 'LATEST_REFRESH_TOKEN';

  axios;

  subscribers = [];

  isRefreshTokenInIssued = false;

  constructor() {
    this.axios = Axios.create({ baseURL: baseUrl });

    this.configAxios();
  }

  get token() {
    return this.TOKEN_KEY_NAME;
  }

  fetchToken = async (params) => {
    return AuthApi.fetchToken(params).then((res) => {
      const data = res.data.result;
      if (data.token) {
        const tokenData = {
          token: data.token,
        };
        this.saveToLS(tokenData);
        return data.token;
      }

      return Promise.reject(new Error('INVALID LOGIN'));
    });
  };

  configAxios = () => {
    this.axios.interceptors.request.use((config) => {
      const token = localStorage.getItem('TOKEN') ?? '';
      // config.headers.Authorization = this.parseJwt();
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['Content-Type'] = 'application/json;charset=utf-8';

      return config;
    });

    this.axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (get(error, 'response.status', 400) === 401) {
          return this.refreshTokenAndRetry(error);
        }
        if (get(error, 'response.status', 400) === 403) {
          // window.location.href = '/not-found';
        }
        return Promise.reject(error);
      },
    );
  };

  refreshTokenAndRetry = async (error) => {
    const onAccessTokenFetched = () => {
      this.subscribers.forEach((callback) => callback());
      this.subscribers = [];
    };

    const addSubscriber = (callback) => {
      this.subscribers.push(callback);
    };

    try {
      const errorResponse = get(error, 'response');

      const retryOriginalRequest = new Promise((resolve) => {
        addSubscriber(() => resolve(this.axios(errorResponse.config)));
      });

      if (!this.isRefreshTokenInIssued) {
        this.isRefreshTokenInIssued = true;
        await this.refreshToken();
        this.isRefreshTokenInIssued = false;
        onAccessTokenFetched();
      }
      // Set latest token refresh time
      // localStorage.setItem(this.REFRESH_TOKEN_KEY, '' + new Date().getTime());

      return retryOriginalRequest;
    } catch (error) {
      this.clearStorage();
      this.removeLastUserLocation();
      window.location.href = './sign-in';
      Promise.reject(error);
    }
  };

  removeLastUserLocation = () => {
    localStorage.removeItem('last-location');
  };

  refreshToken = async () => {
    const token = getLS(this.TOKEN_KEY_NAME);
    const result = await AuthApi.refreshToken(token);
    this.saveToLS(result.data);
    return result;
  };

  saveToLS = (credentials) => {
    const { token } = credentials;
    localStorage.setItem(this.TOKEN_KEY_NAME, token);
  };
}

const authService = new AuthService();

export default function pdfDownloader(url, file_name) {
  return authService.axios.get(url, { responseType: 'blob' }).then((response) => {
    const blob = new Blob([response.data], { type: 'application/pdf' });
    FileSaver.saveAs(blob, file_name);
  });
}
